import React from 'react'
import './page.css'
import Header from '../components/Header/Header'
import About from '../components/about/About'
import Footer from '../components/footer/Footer'
import Contact from '../components/contact/Contact'
import Faq from '../components/Faq/Faq'
const Aboutpage = () => {
  return (
    <main className='landpage gold-page'>
    <Header />
      <section className='about-landpage'>
        <div className="about-page-text">
          <h3>about Quantum Assets Global Ledger</h3>
          <span className="small-thin-line"></span>
        </div>
      </section>
      <About />
      <Faq />
      <Contact />
      <Footer />
    </main>
  )
}

export default Aboutpage